import { render, staticRenderFns } from "./IM_1_7.vue?vue&type=template&id=5a8a1b5e&"
import script from "./IM_1_7.vue?vue&type=script&lang=js&"
export * from "./IM_1_7.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports